/* DivineYug — temple bell on add-to-cart and buy-now.

   The sound is a recorded Indian temple bell (Pixabay Content License: free for
   commercial use, no attribution required), served from our own Files. If it
   fails to load for any reason we fall back to a synthesised bell, so the
   confirmation chime never just goes missing.

   Volume is deliberately low — the recording is loud and plays at full scale on
   the sites it came from. window.DH_BELL_VOLUME (0–1) overrides it.
   window.DH_BELL_SRC overrides the file.
   A shopper can silence it with  localStorage.setItem('dy-bell','off')  */
(function () {
  var SRC = 'https://cdn.shopify.com/s/files/1/0823/4575/4869/files/divineyug-temple-bell.mp3?v=1791358563';
  var VOL = 0.3;
  var GAP = 600;          /* ms between rings — a double click rings once */
  var last = 0, el = null, dead = false, ctx = null;

  function vol() { return typeof window.DH_BELL_VOLUME === 'number' ? window.DH_BELL_VOLUME : VOL; }
  function muted() {
    try { return localStorage.getItem('dy-bell') === 'off'; } catch (e) { return false; }
  }

  /* Built on the first interaction rather than at load, so the 30 KB is fetched
     only once the shopper is actually using the page. pointerdown fires before
     click, so it is already warm when they hit Add to cart. */
  function warm() {
    if (el || dead) return;
    try {
      el = new Audio(window.DH_BELL_SRC || SRC);
      el.preload = 'auto';
      el.volume = vol();
      el.addEventListener('error', function () { dead = true; el = null; });
    } catch (e) { dead = true; }
  }
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, warm, { once: true, passive: true });
  });

  /* ---- fallback: a struck bell is a sum of inharmonic partials with
     per-partial decay, which is cheap enough to generate on the spot ---- */
  var PARTIALS = [
    [0.50, 0.30, 2.6], [1.00, 1.00, 2.0], [1.19, 0.42, 1.5],
    [1.50, 0.35, 1.3], [2.00, 0.55, 1.1], [2.52, 0.22, 0.8],
    [3.01, 0.20, 0.6], [4.17, 0.12, 0.4], [5.43, 0.08, 0.3],
    [6.80, 0.05, 0.22]
  ];
  function synth() {
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!ctx) ctx = new AC();
    if (ctx.state === 'suspended') ctx.resume();
    var t = ctx.currentTime + 0.001;

    var lp = ctx.createBiquadFilter(); lp.type = 'lowpass';  lp.frequency.value = 7000;
    var hp = ctx.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 180;
    var master = ctx.createGain(); master.gain.value = vol() * 0.55;
    lp.connect(hp); hp.connect(master); master.connect(ctx.destination);

    /* ~30ms of bandpassed noise for the clapper hitting the metal */
    var n = Math.floor(ctx.sampleRate * 0.03);
    var buf = ctx.createBuffer(1, n, ctx.sampleRate), d = buf.getChannelData(0);
    for (var i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / n);
    var src = ctx.createBufferSource(); src.buffer = buf;
    var bp = ctx.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 3200; bp.Q.value = 1.1;
    var ng = ctx.createGain();
    ng.gain.setValueAtTime(0.5, t);
    ng.gain.exponentialRampToValueAtTime(0.0001, t + 0.03);
    src.connect(bp); bp.connect(ng); ng.connect(lp);
    src.start(t); src.stop(t + 0.04);

    PARTIALS.forEach(function (p, i) {
      /* detuned twins on the two loudest partials; the slow beat between them
         is the shimmer you hear in a real bell */
      ((i === 1 || i === 4) ? [0, 0.7] : [0]).forEach(function (off) {
        var o = ctx.createOscillator(); o.type = 'sine';
        o.frequency.value = 620 * p[0] + off;
        var g = ctx.createGain();
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(p[1] * 0.3, t + 0.004);
        g.gain.exponentialRampToValueAtTime(0.0001, t + p[2]);
        o.connect(g); g.connect(lp);
        o.start(t); o.stop(t + p[2] + 0.05);
      });
    });
  }

  function play() {
    if (muted()) return;
    var now = Date.now();
    if (now - last < GAP) return;
    last = now;

    warm();
    if (el) {
      el.volume = vol();
      try { el.currentTime = 0; } catch (e) {}
      var p = el.play();
      /* a rejection here is the browser's autoplay policy, not a broken file —
         the synth needs the same gesture, so there is nothing to fall back to */
      if (p && p.catch) p.catch(function () {});
      return;
    }
    try { synth(); } catch (e) {}
  }

  window.dhBell = play;

  /* Capture phase, so the ring starts before any handler navigates away. */
  var SEL = '[data-buynow],[data-add],button[name="add"],[data-dh-add]';
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest(SEL)) play();
  }, true);

  /* every add-to-cart form, including the cards on collection and search */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') !== -1) play();
  }, true);
})();
